import React from 'react';
import './HomeAbout.css'
import HomeAboutNavbar from './HomeAboutNavbar';
import { Outlet } from 'react-router-dom';

const HomeAbout = () => {
    return (
        <div className='home-about-container'>
            <div className='container'>
                <HomeAboutNavbar></HomeAboutNavbar>
                <div className='home-about-outlet p-5'>
                    <Outlet></Outlet>
                </div>
            </div>
        </div>
    );
};

export default HomeAbout;